import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapAgentResp } from "@/redux/mappers/Customer/Agent/AgentMapper";

export const Agentslice = createApi({
  reducerPath: "agentApi",
  baseQuery,
  tagTypes: ["agent"],
  endpoints: (builder) => ({
    getAgent: builder.query({
      query: ({ id }) =>`/customers/agent/saveAgent/${id}`,
      transformResponse: (response) => mapAgentResp(response?.data) ?? "",
      providesTags: ["agent"],
    }),

    createAgent: builder.mutation({
      query: ({ id, ...data }) => ({
        url:`/customers/agent/saveAgent/${id}`, 
        method: "PUT",
        headers: { 
          "X-Request-Id": Math.random().toString(36).substring(2)
        },
        body: { request: data },
      }),
      invalidatesTags: ["agent"],
    }),
 
  }),
});

export const {
 useLazyGetAgentQuery,
 useCreateAgentMutation 
} = Agentslice;
